import gql from "graphql-tag";

export const PREVIEW_INVOICE = gql`
  query previewInvoice($invoiceId: ID!, $workspaceId: ID!) {
    previewInvoice(invoiceId: $invoiceId, workspaceId: $workspaceId)
  }
`;
